import React from "react";
import { Alert } from "@icg360/ui-toolkit";
export default function DiscountsAndSurchargesMessage() {
  return /*#__PURE__*/React.createElement(Alert, {
    bsStyle: "info"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Note: "), "some discounts may not affect the premium at this time. We recommend endorsing the policy because it may become eligible if other discounts expire."));
}